interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: "primary" | "secondary" | "danger" | "ghost";
	size?: "sm" | "md" | "lg";
}

const variantClasses: Record<string, string> = {
	primary: "bg-accent-primary text-bg-primary hover:bg-accent-primary/90 font-semibold",
	secondary: "bg-bg-tertiary text-text-primary border border-border-default hover:bg-bg-elevated",
	danger:
		"bg-accent-danger/15 text-accent-danger border border-accent-danger/30 hover:bg-accent-danger/25",
	ghost: "text-text-secondary hover:text-text-primary hover:bg-bg-tertiary",
};

const sizeClasses: Record<string, string> = {
	sm: "text-xs px-2 py-1 rounded",
	md: "text-sm px-3 py-1.5 rounded-md",
	lg: "text-base px-4 py-2 rounded-md",
};

export function Button({
	variant = "secondary",
	size = "md",
	className = "",
	children,
	...props
}: ButtonProps) {
	return (
		<button
			className={`inline-flex items-center justify-center gap-1.5 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
			{...props}
		>
			{children}
		</button>
	);
}
